module.exports = __webpack_public_path__ + "static/media/complete-warn.b993cd39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/complete-warn.svg
// module id = 228
// module chunks = 0